/* eslint-disable react/jsx-props-no-spreading */
import { TextInput, TextInputProps } from '@mantine/core';
import { useState, useEffect } from 'react';
import { isValidUUID } from '@/utils';

interface UUIDInputProps extends Omit<TextInputProps, 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

const UUIDInput = ({ value, onChange, error, ...props }: UUIDInputProps) => {
    const [inputValue, setInputValue] = useState(value);

    // Update inputValue when value prop changes
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.currentTarget.value;
        setInputValue(newValue);

        // Only update parent value if input is empty or a valid UUID
        if (newValue === '' || isValidUUID(newValue)) {
            onChange(newValue);
        }
    };

    const validationError =
        inputValue && !isValidUUID(inputValue)
            ? 'Invalid UUID format'
            : undefined;
    const displayError = error ?? validationError;

    return (
        <TextInput
            {...props}
            error={displayError}
            placeholder="Enter valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"
            value={inputValue}
            onChange={handleChange}
        />
    );
};

export default UUIDInput;
